import React from "react";

// material-ui components
import Modal from "material-ui/Modal/Modal";

// core components
import IconCard from "components/Cards/IconCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Button from "components/CustomButtons/Button.jsx";


import SimpleInput from "components/SimpleInput/SimpleInput.jsx";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";


function SimpleForm({ ...props }) {
    let {
      editId,
      classes,
      state,
      fields,
      open,
      onChange,
      onSubmit,
      onCancel,
    } = props; 

    return (
          <Modal open={open}>
            <GridContainer style={getModalStyle()} justify="center">
              <ItemGrid xs={12} sm={12} md={6}>
                <IconCard
                  icon={Assignment}
                  iconColor="rose"
                  title="Edit"
                  content={
                    <form>
                        <div>
                          <GridContainer>
                            {fields.map((prop,key)=>{
                                return (
                                  <SimpleInput key={editId+"-"+key} type={prop.type} formName="edit" name={prop.name} label={prop.label} classes={classes} size={prop.size} value={state[prop.name]} handler={onChange} />
                                )})
                            }
                          </GridContainer>
                          <GridContainer justify="flex-end">
                            <ItemGrid xs={12} sm={12} md={6}>
                              <Button color="rose" onClick={onSubmit}>Submit</Button>
                            </ItemGrid>
                            <ItemGrid xs={12} sm={12} md={6}>
                              <Button onClick={onCancel}>Cancel</Button>
                            </ItemGrid>
                          </GridContainer>
                        </div>
                    </form>
                  }
                />
              </ItemGrid>
            </GridContainer>
          </Modal>
      );

  }


function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    position: 'absolute',
    width: "80%",
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}


  export default SimpleForm;



// WEBPACK FOOTER //
// ./src/components/SimpleForm/SimpleForm.jsx